import { DomainError } from '@w/utils'
import { makeI18nArgs } from '@w/react-i18n'
import type { ContentBlocksEditorTranslations } from './i18n'

const args = makeI18nArgs<ContentBlocksEditorTranslations>()

export type ContentBlocksEditorErrorType = 'FILE_UPLOAD_FAILED'

export class ContentBlocksEditorError extends DomainError<ContentBlocksEditorErrorType> {}

export function fileUploadFailedError(cause?: Error) {
  return new ContentBlocksEditorError(
    'FILE_UPLOAD_FAILED',
    'File upload failed',
    args('contentBlocksEditor.errors.fileUploadFailed'),
    { cause },
  )
}
